import {reactive} from 'vue';

class PageStore {
  activeVoucherCode: string = null;

  constructor() {
    if (window.__globalConfig) {
      this.activeVoucherCode = window.__globalConfig.activeVoucherCode;
    }
  }
}

const promotionTeaserStore = new PageStore();
export default reactive(promotionTeaserStore);
export {PageStore};
